import axios from "axios";
import { getHost } from "@/utils/utils";
const loginAxiosInstance = axios.create({
  baseURL: getHost(),
  headers: {
    Authorization: "Basic cmVucmVuaW86cmVucmVuaW8=",
  },
});
export default loginAxiosInstance